import { IonContent, IonPage } from '@ionic/react';
import React, { FunctionComponent } from 'react';
import FishAnimation from '../components/Animation/Fish';
import LoginForm from '../components/Auth/LoginForm';

interface LoginProps { };

const Login: FunctionComponent<LoginProps> = () => {

    const styles = {
        title: {
            fontSize: "48pt",
            fontWeight: 400,
            margin: 0,
            marginTop: 40
        } as React.CSSProperties,

        subTitle: {
            fontSize: 14,
            fontWeight: 400,
            marginTop: 0,
            marginBottom: 48,
        } as React.CSSProperties,
    }

    return (
        <IonPage>
            <IonContent scrollY={false} className="ion-padding ion-margin">
                    <h1 style={styles.title}>Login</h1>
                    <h2 style={styles.subTitle}>- og velkommen tilbage</h2>

                    <LoginForm />

                    <FishAnimation />
            </IonContent>
        </IonPage>
    );
}

export default Login;